import FeatureFlags from '@/gf/modules/FeatureFlags'
import { Session, SessionPayload } from '../types'

const fromPayload = (payload: SessionPayload): Session => ({
  ...payload,
  featureFlags: FeatureFlags.fromPayload(payload.featureFlags),
})

export default { fromPayload }
